import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { pickTab } from '../navigation/tabs';

/**
 * A page's tab, kept in the address (?tab=...), so a link from Home or an email opens the right tab and the
 * address can be shared. A tab the person may not see falls back to the default.
 */
export function useTabParam(allowed, fallback, name = 'tab') {
    const [params, setParams] = useSearchParams();
    const tab = pickTab(params.get(name), allowed, fallback);
    const setTab = useCallback((next) => {
        setParams(prev => {
            const p = new URLSearchParams(prev);
            if (next === fallback) p.delete(name); else p.set(name, next);
            return p;
        }, { replace: true });
    }, [setParams, fallback, name]);
    return [tab, setTab];
}
